var _ellipse, _ellipse2, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 26.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_11321_50318)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5389,
    cy: 26.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_11321_50318)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 11,
    fill: "#D96525",
    stroke: "#D96525",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.1875C19.1272 15.0124 18.9344 15.8262 18.5625 16.5625C18.1215 17.4449 17.4436 18.187 16.6047 18.7058C15.7657 19.2246 14.7989 19.4996 13.8125 19.5C12.9876 19.5022 12.1738 19.3094 11.4375 18.9375L7.875 20.125L9.0625 16.5625C8.69058 15.8262 8.49785 15.0124 8.5 14.1875C8.50038 13.2011 8.77538 12.2343 9.2942 11.3954C9.81302 10.5564 10.5552 9.8785 11.4375 9.43752C12.1738 9.0656 12.9876 8.87287 13.8125 8.87502H14.125C15.4277 8.94689 16.6582 9.49674 17.5807 10.4193C18.5033 11.3419 19.0531 12.5723 19.125 13.875V14.1875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11321_50318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 26.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11321_50318",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5389 26.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsActive);
export default __webpack_public_path__ + "static/media/comments-active.9c9c1cbe6f15e862f9f06c3d373f5801.svg";
export { ForwardRef as ReactComponent };